import Vue from 'vue'
import moment from 'moment-timezone'

let pad = (num) => {
  return ('0' + num).slice(-2)
}

const filters = {
  humanFileSize (bytes) {
    let thresh = 1000
    let units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    let u = -1

    if (Math.abs(bytes) < thresh) {
      return bytes + ' B'
    }

    do {
      bytes /= thresh
      ++u
    } while (Math.abs(bytes) >= thresh && u < units.length - 1)

    return bytes.toFixed(1) + ' ' + units[u]
  },
  time (seconds) {
    let minutes = Math.floor(seconds / 60)
    let secs = seconds % 60
    minutes = minutes % 60

    return pad(minutes) + ':' + pad(secs)
  },
  money (cents) {
    let cost = (Math.round((cents / 100) * 100) / 100)
    return cost < 0 ? 0 : cost
  },
  date (date) {
    return moment(date).format('DD-MM-YYYY')
  },
  formatDate (date, format) {
    return moment(date).format(format)
  },
  percent (num) {
    return num + '%'
  }
}

for (let [key, value] of Object.entries(filters)) {
  Vue.filter(key, value)
}

// Format a UTC datetime string (as the backend returns last_connected etc.) in a
// target timezone — pass the display's `timezone`; falls back to the viewer's
// local time when no timezone is given. Usable in templates and attribute binds.
Vue.prototype.$localTime = function (utcString, tz, format = 'YYYY-MM-DD HH:mm') {
  if (!utcString) return '-'
  // last_connected comes back as "YYYY-MM-DD HH:mm:ss"; parse with that format so
  // moment treats it as UTC (and doesn't fall back to the native Date parser)
  let m = moment.utc(utcString, 'YYYY-MM-DD HH:mm:ss')
  if (!m.isValid()) m = moment.utc(utcString)
  if (!m.isValid()) return utcString
  return (tz ? m.tz(tz) : m.local()).format(format)
}
